import script from "./ResultImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultImage.vue?vue&type=script&setup=true&lang=ts"

import "./ResultImage.scss?vue&type=style&index=0&id=78fae45b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78fae45b"]])

export default __exports__